import React from "react";

const QuizNotAvailable = ({}) => {
	return (
		<div className="flex flex-col items-center w-full h-full mt-16 min-w-80 max-w-80 sm:min-w-96 sm:max-w-96 bg-white p-6 rounded-2xl shadow-[6px_6px_0px_rgba(0,0,0,0.3)] ">
			<h1 className="text-2xl text-gray-600 font-bold text-center mb-8">
				Ce quiz n'est plus accessible.
			</h1>
			<p className="text-gray-600 my-3">
				Ce quiz etait soit supprimé, soit il a expiré. Rapprochez vous de la
				personne vous ayant invité a ce quiz pour en savoir plus.
			</p>
		</div>
	);
};

export default QuizNotAvailable;
